

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const weightreduction: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "weight-reduction-program",
        "meta": {
            "title": "Medically Supervised Weight Loss Program | Elite Body Home",
            "description": "Our medically supervised weight loss program helps with long-term weight management through personalized nutrition, exercise, and behavioral therapy.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/weight-reduction-program/",
            "og": {
                "title": "Medically Supervised Weight Loss Program | Elite Body Home",
                "description": "Comprehensive weight management program combining medical supervision, nutrition, and behavioral therapy",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Weight Reduction Program"],
        "hero": {
            "title": "Elite Body Home Weight Reduction Program",
            "subtitle": "Medically Supervised Long-Term Weight Loss",
            "description": "It's a medically supervised program designed to help with long-term weight loss, whether you want to lose a couple of pounds or change your lifestyle completely."
        },
        "howItWorks": {
            "title": "What to Expect from Our Weight Loss Program",
            "description": "Our comprehensive lab testing includes: TSH, Lipid Profile, ALT/SGPT, Uric Acid, AST/SGOT, Creatinine, Albumin, GGT, ALP, Total Bilirubin, Total Protein, Direct Bilirubin, Calcium, BUN, Iron, Sodium, Chloride, Potassium, and Complete Blood Count (CBC)."
        },
        "procedureSteps": {
            "heading": "Procedure",
            "para": "Our program for weight loss/increasing calorie usage is a comprehensive approach to weight loss in which nutrition, physical activity, behavioral counseling and, when necessary, medical treatment are tailored for you. The objective is to develop a plan that is sustainable and results in weight loss and also improved overall health.",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Comprehensive review of your medical history, lifestyle, and objectives.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "Personalized Plan",
                    "desc": "A personalized treatment plan based on your nutrition, exercise, and lifestyle changes.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "Medical Supervision",
                    "desc": "Continued lab tests and medical imaging may also be required.",
                    "icon": "fa-solid fa-stethoscope"
                },
                {
                    "title": "Behavioral Therapy",
                    "desc": "Sessions intended to alter eating patterns, to counter emotional triggers, to be better after eating.",
                    "icon": "fa-solid fa-brain"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits",
            "subheading": "Life Beyond Weight Loss",
            "para": "Benefits of Participating in a Weight Reduction Program Our program is individualized for your health, with slow, sustainable changes.",
            "items": [
                {
                    "title": "Safe and Supervised",
                    "desc": "Medical experts monitor every single step, maximizing health and safety.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "Sustainable Results",
                    "desc": "In place of wizardry, our program focuses on enduring transformations in lifestyle and habits.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "Improved Health",
                    "desc": "Decreased risk of chronic conditions, such as diabetes, heart disease, and hypertension.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "Better Energy Levels",
                    "desc": "Better nutrition and exercise routines can help you feel more energetic and alive.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "eligibility": {
            "heading": "Eligibility",
            "subheading": "",
            "para": "The weight loss program for people who are serious about losing weight and also improving their health. However, there are some things to consider for eligibility.",
            "items": [
                {
                    "title": "Overweight or Obese",
                    "desc": "Those with a BMI of 25 or more.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Chronic Disease Risk",
                    "desc": "People who have, or are at risk of, conditions such as heart disease, type 2 diabetes or hypertension.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "Past Failed Attempts",
                    "desc": "If diet and exercise alone have been unsuccessful for you.",
                    "icon": "fa-solid fa-redo"
                },
                {
                    "title": "Wanting Healthier Life",
                    "desc": "If you want a well-rounded, sustainable approach to not just lose weight, but also keep weight off.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation",
            "subheading": "",
            "para": "Getting ready for a weight loss plan is both a mental and physical endeavor. Be dedicated and ready for a weight loss lifestyle.",
            "items": [
                {
                    "title": "Set Realistic Goals",
                    "desc": "Our team will help you process to maintain realistic, attainable individual weight loss goals.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "Understand the Process",
                    "desc": "Know what all the steps entail, from diet changes to exercising.",
                    "icon": "fa-solid fa-book"
                },
                {
                    "title": "Prepare Mentally",
                    "desc": "Losing weight is a long-term process. It is not a simple nor is it a fast process.",
                    "icon": "fa-solid fa-brain"
                }
            ]
        },
        "results": {
            "heading": "Results",
            "subheading": "",
            "para": "Results vary from participant to participant from our fat burning program, but previous participants are usually able to reduce weight in a sustained method and improve physical fitness and well being.",
            "items": [
                {
                    "title": "Steady Weight Loss",
                    "desc": "Losing 1-2 pounds (0.5-1 kg) per week, a safe, sustainable rate.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Improved Health",
                    "desc": "Reduced blood pressure, cholesterol and blood sugar levels.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Boosted Confidence",
                    "desc": "Improved self-image and confidence as you achieve your weight goals.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Why Choose Elite Body Home?",
            "subheading": "",
            "para": "The weight reduction program at Elite Body Home is an individualized program tailored to your specific needs and goals. We focus on the bigger picture of health — losing weight is much more than finding a diet that works for you; it is about how food and activity interact with your lifestyle. And through innovative treatments such as fat-burning injections, IV therapies, and non-invasive body contouring, we guide you towards speedy, noticeable results.",
            "items": []
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How much weight can I expect to lose?",
                    "answer": "Most participants lose 1-2 pounds per week, which is a safe and sustainable rate of weight loss."
                },
                {
                    "question": "Is medication required for the program?",
                    "answer": "Medication may be recommended in certain cases, especially for individuals who have difficulty losing weight through lifestyle changes alone. This option will be discussed during your medical consultation."
                },
                {
                    "question": "Can I still enjoy my favorite foods?",
                    "answer": "Our nutritional plan focuses on balance and moderation rather than deprivation, so you can enjoy your favorite foods occasionally within a healthy lifestyle."
                },
                {
                    "question": "How long does the program typically last?",
                    "answer": "The duration depends on your personal goals and response to the program, but most participants remain in the program for 3 to 6 months to achieve tangible and sustainable results."
                }
            ]
        }
    },
    "ar": {
        "url": "weight-reduction-program",
        "meta": {
            "title": "برنامج فقدان الوزن تحت الإشراف الطبي | ايليت بودي هوم",
            "description": "برنامج متكامل لفقدان الوزن تحت الإشراف الطبي، يجمع بين التغذية والنشاط البدني والإرشاد السلوكي لتحقيق نتائج مستدامة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/weight-reduction-program/",
            "og": {
                "title": "برنامج فقدان الوزن تحت الإشراف الطبي | ايليت بودي هوم",
                "description": "برنامج شامل لإدارة الوزن يجمع بين الإشراف الطبي والتغذية والعلاج السلوكي",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-53.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "برنامج فقدان الوزن"],
        "hero": {
            "title": "برنامج فقدان الوزن في ايليت بودي هوم",
            "subtitle": "فقدان الوزن تحت الإشراف الطبي لنتائج طويلة الأمد",
            "description": "نقدم لك في عيادات ايليت بودي هوم برنامج خسارة الوزن بمنهج شامل يساعدك على الوصول إلى الوزن المثالي بطريقة آمنة وفعالة. سواء كنت ترغب في خسارة بضع كيلوجرامات أو تسعى إلى تغيير جذري في نمط حياتك، يوفر لك حلاً تحت إشراف طبي يركز على النتائج طويلة الأمد."
        },
        "howItWorks": {
            "title": "ما يتضمنه برنامج تقليل الوزن",
            "description": "تحاليل الغدة الدرقية، تحاليل الدهون الشاملة، تحليل إنزيم ناقلة أمين الألانين، تحليل حمض اليوريك، تحليل إنزيم ناقلة أمين الاسبارتات، تحليل الكرياتينين، تحليل الألبومين، تحليل إنزيم ناقل الغاما غلوتاميل، تحليل الفوسفاتاز القلوي، تحليل البيليروبين الكلي، تحليل البروتين الكلي في الدم، تحليل البيليروبين المباشر (المقترن)، تحليل الكالسيوم، تحليل نيتروجين اليوريا في الدم، تحليل الحديد، تحليل الصوديوم في الدم، تحليل الكلوريد في الدم، تحليل البوتاسيوم في الدم، تحليل صورة دم كاملة."
        },
        "procedureSteps": {
            "heading": "آلية البرنامج",
            "para": "يُعد برنامج إنقاص الوزن في ايليت بودي هوم حل شامل ومُصمم خصيصًا ليناسب احتياجات كل فرد، ويجمع بين التغذية، والنشاط البدني، والإرشاد السلوكي، والتدخلات الطبية عند الحاجة. يهدف إلى وضع خطة مستدامة تُحقق خسارة الوزن وتحسن الحالة الصحية بشكل عام.",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "يتم خلالها تقييم دقيق للتاريخ الطبي، ونمط الحياة، والأهداف المرجوة.",
                    "icon": "fa-solid fa-comment-medical"
                },
                {
                    "title": "خطة علاج مخصصة",
                    "desc": "تصميم خطة فردية لخسارة الوزن تشمل نظامًا غذائيًا مناسبًا، وروتين لممارسة التمارين الرياضية، وتعديلات في نمط الحياة.",
                    "icon": "fa-solid fa-clipboard-list"
                },
                {
                    "title": "إشراف طبي مستمر",
                    "desc": "يتضمن متابعة منتظمة من قبل فريق طبي متخصص، لمراقبة التقدم وضمان سلامة الإجراءات المتبعة.",
                    "icon": "fa-solid fa-stethoscope"
                },
                {
                    "title": "العلاج السلوكي",
                    "desc": "يشمل جلسات مصممة لتعديل العادات الغذائية، والتعامل مع المحفزات العاطفية، وتعزيز التغييرات السلوكية الإيجابية والمستمرة.",
                    "icon": "fa-solid fa-brain"
                }
            ]
        },
        "benefits": {
            "heading": "الفوائد",
            "subheading": "",
            "para": "يمنحك الانضمام إلى برنامج تقليل الوزن في ايليت بودي هوم مزايا صحية تتجاوز مجرد خسارة الكيلوجرامات؛ لأن هدفنا هو تعزيز صحتك العامة وتحقيق تغييرات دائمة وآمنة في نمط حياتك.",
            "items": [
                {
                    "title": "إشراف طبي آمن",
                    "desc": "تتم متابعة البرنامج من قِبل أطباء متخصصين لضمان السلامة وتقليل المخاطر الصحية.",
                    "icon": "fa-solid fa-shield-alt"
                },
                {
                    "title": "نتائج مستدامة",
                    "desc": "نعتمد نهجًا طويل الأمد، يركز على تغيير العادات ونمط الحياة وليس الحلول السريعة المؤقتة.",
                    "icon": "fa-solid fa-check-circle"
                },
                {
                    "title": "تحسين الصحة العامة",
                    "desc": "تقليل خطر الإصابة بالأمراض المزمنة مثل مرض السكري، وارتفاع ضغط الدم، وأمراض القلب.",
                    "icon": "fa-solid fa-heart"
                },
                {
                    "title": "زيادة الطاقة والنشاط",
                    "desc": "يساعد النظام الغذائي المتوازن والتمارين المنتظمة على تعزيز الحيوية والنشاط.",
                    "icon": "fa-solid fa-bolt"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية",
            "subheading": "",
            "para": "يُصمم برنامج تقليل الوزن في ايليت بودي هوم للأشخاص الجادين في تغيير نمط حياتهم بهدف خسارة الوزن وتحسين صحتهم. ومع ذلك، توجد بعض المعايير التي نأخذها في الاعتبار لتحديد الأهلية.",
            "items": [
                {
                    "title": "زيادة الوزن أو السمنة",
                    "desc": "يناسب الأشخاص الذين لديهم مؤشر كتلة جسم (BMI) يساوي 25 أو أكثر.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "المعرضون لخطر الأمراض المزمنة",
                    "desc": "يلائم بعض المرضى مثل مرضى السكري من النوع الثاني، أو ارتفاع ضغط الدم، أو أمراض القلب.",
                    "icon": "fa-solid fa-exclamation-triangle"
                },
                {
                    "title": "تجارب سابقة لفقدان الوزن",
                    "desc": "إذا لم تنجح محاولاتك السابقة في خسارة الوزن من خلال النظام الغذائي والرياضة فقط.",
                    "icon": "fa-solid fa-redo"
                },
                {
                    "title": "الرغبة في نمط حياة صحي",
                    "desc": "إذا كنت تسعى إلى نهج مدروس وآمن للحفاظ على وزن صحي بشكل مستمر.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد",
            "subheading": "",
            "para": "يتطلب الاستعداد لبدء برنامج تقليل الوزن جاهزية نفسية وجسدية، حيث يعتمد نجاح البرنامج بشكل كبير على مدى التزامك واستعدادك لإجراء تغييرات مستدامة في نمط حياتك.",
            "items": [
                {
                    "title": "تحديد أهداف واقعية",
                    "desc": "اعمل مع فريقنا الطبي لوضع أهداف قابلة للتحقيق.",
                    "icon": "fa-solid fa-bullseye"
                },
                {
                    "title": "فهم خطوات البرنامج",
                    "desc": "احرص على معرفة المراحل التي ستمر بها، بدءًا من التغيرات الغذائية إلى ممارسة التمارين.",
                    "icon": "fa-solid fa-book"
                },
                {
                    "title": "الاستعداد النفسي",
                    "desc": "تُعد خسارة الوزن عملية التزام طويلة الأمد. كن مستعدًا لعملية تدريجية دون توقع نتائج فورية.",
                    "icon": "fa-solid fa-brain"
                }
            ]
        },
        "results": {
            "heading": "النتائج",
            "subheading": "",
            "para": "تختلف النتائج من شخص لآخر، لكن يحقق معظم المشاركين في برنامج تقليل الوزن لدينا تحسنًا ملحوظًا في الوزن واللياقة البدنية والصحة العامة بمرور الوقت.",
            "items": [
                {
                    "title": "فقدان تدريجي للوزن",
                    "desc": "تتحقق خسارة وزن ثابتة بمعدل يتراوح بين 1 إلى 2 رطل أسبوعيًا.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "تحسن في الصحة",
                    "desc": "يعمل البرنامج على خفض ضغط الدم، وتحسين في مستويات الكوليسترول، وتنظيم أفضل لسكر الدم.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "تعزيز الثقة بالنفس",
                    "desc": "تزداد ثقتك بمظهرك وصورتك الذاتية مع الوصول إلى أهدافك في الوزن.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "لماذا تختار ايليت بودي هوم؟",
            "subheading": "",
            "para": "نقدم في ايليت بودي هوم برنامجًا متكاملًا لتقليل الوزن، يعتمد على نهج شخصي مصمم خصيصًا ليتناسب مع احتياجاتك وأهدافك الفردية. يضم فريقنا نخبة من الأطباء وأخصائيي التغذية المعتمدين والمتخصصين في أحدث تقنيات إدارة الوزن لضمان نتائج آمنة، وفعالة، ودائمة.",
            "items": []
        },
        "faqData": {
            "heading": "الأسئلة المتكررة",
            "subheading": "",
            "items": [
                {
                    "question": "كم من الوزن يمكنني أن أخسر؟",
                    "answer": "تختلف النتائج بناءً على العوامل الفردية مثل الوزن الأساسي، ومدى الالتزام بالبرنامج، ومعدل الأيض. ومع ذلك، يمكن لمعظم المشاركين توقع خسارة وزن تدريجية وآمنة بمعدل يتراوح بين 1 إلى 2 رطل أسبوعيًا."
                },
                {
                    "question": "هل يتطلب تناول أدوية؟",
                    "answer": "قد يُوصى باستخدام أدوية في حالات معينة، خاصةً للأشخاص الذين يواجهون صعوبة في فقدان الوزن من خلال تعديل نمط الحياة فقط. سيتم مناقشة هذا الخيار خلال الاستشارة الطبية."
                },
                {
                    "question": "هل يمكنني الاستمتاع بطعامي المفضل؟",
                    "answer": "تركز خطتنا الغذائية على التوازن والاعتدال بدلاً من الحرمان؛ لذا، يمكنك الاستمتاع بأطعمتك المفضلة من وقت لآخر ضمن نمط حياة صحي ومتوازن."
                },
                {
                    "question": "كم تستغرق مدة البرنامج؟",
                    "answer": "تعتمد مدة البرنامج على أهدافك الشخصية وسرعة استجابتك. لكن في الغالب، يبقى المشاركون في البرنامج لمدة تتراوح بين 3 إلى 6 أشهر لتحقيق نتائج ملموسة ومستدامة."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Weight-Reduction-Program-scaled.jpg ",
            "beforeAfter": []
        },
        "product": {
            "id": 47,
            "title": "Weight Reduction Program in Dubai",
            "description": "Medically supervised comprehensive weight management program",
            "price": 1500
        }
    }
}